module.exports = __webpack_public_path__ + "static/media/conciseblue.5d767c96.svg";